import { FIELDS, } from "./fields.js";
/**
 * The `brand.json` keys that are metadata rather than design fields: they carry
 * no CSS variable and no value a surface draws with, so a reader that walks the
 * fields has to be told about them separately.
 *
 * Every reader that tells a real key from an unknown one works from this list.
 * Hand-maintained copies drift: `colorScheme` was added to the contract while
 * the SDK's own allowlist stayed behind, and `strict: true` then rejected the
 * `brand.json` the Studio exports. `dark` is deliberately absent - it holds
 * fields, and each reader handles it on its own terms.
 */
export const BRAND_META_KEYS = [
    "$schema",
    "schemaVersion",
    "colorScheme",
    "fontFaces",
];
export const BRAND_CSS_VARS = Object.fromEntries(FIELDS.filter((f) => f.themeVar).map((f) => [f.key, f.cssVar]));
// `light-dark()` takes colours only, so a gradient's dark value has its own variable.
export const BRAND_DARK_CSS_VARS = Object.fromEntries(FIELDS.filter((f) => f.kind === "gradient").map((f) => [
    f.key,
    `${f.cssVar}-dark`,
]));
/** Raising this means adding a migration in `migrate.ts`. */
export const SCHEMA_VERSION = 1;
